import { useSelector } from 'react-redux';
import { StateAdvertContacts } from '#advertContacts/types';

const useAdvertContactsState = (): StateAdvertContacts => useSelector(
  (state: { advertContacts: StateAdvertContacts }) => state.advertContacts,
);

export { useAdvertContactsState };
